import { render } from "./QHLSOperation.vue?vue&type=template&id=310e7baa&scoped=true"
import script from "./QHLSOperation.vue?vue&type=script&lang=js"
export * from "./QHLSOperation.vue?vue&type=script&lang=js"

import "./QHLSOperation.vue?vue&type=style&index=0&id=310e7baa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-310e7baa"]])

export default __exports__